import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import lottie, { AnimationItem } from "lottie-web";
import LoanLightLoaderJSON from "../assets/animations/loanlight-loader.json";
export const LoanLightLoading = t0 => {
  const $ = _c(4);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (containerRef.current) {
        animationRef.current = lottie.loadAnimation({
          container: containerRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: LoanLightLoaderJSON
        });
      }
      return () => {
        animationRef.current?.destroy();
      };
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  const t4 = size === "sm" ? "w-12 h-12" : "w-20 h-20";
  let t5;
  if ($[2] !== t4) {
    t5 = <div ref={containerRef} className={t4} />;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
};